const Separate: React.FC<{}> = () => {
  return <div className="h-1 w-full bg-gray-200"></div>;
};

export default Separate;
